import constantFactory from "@gaoding/constant-factory";

export const { REPORT, REPORT_LIST, REPORT_MAP, REPORT_ITEM_MAP } =
  constantFactory("REPORT", [
    {
      key: "SPAM",
      label: "垃圾广告",
      value: 0,
    },
    {
      key: "PORN",
      label: "淫秽色情",
      value: 1,
    },
    {
      key: "FAKE",
      label: "虚假中奖",
      value: 2,
    },
    {
      key: "SENSITIVE",
      label: "敏感信息",
      value: 3,
    },
    {
      key: "ATTACK",
      label: "人身攻击",
      value: 4,
    },
    {
      key: "HARASS",
      label: "骚扰他人",
      value: 5,
    },
    {
      key: "DISLIKE",
      label: "我不喜欢",
      value: 7,
    },
    {
      key: "OTHER",
      label: "其他原因",
      value: 99,
    },
  ]);
